var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.87216 13.5C2.53538 13.5 2.25033 13.3833 2.01699 13.15C1.78366 12.9167 1.66699 12.6316 1.66699 12.2948V4.70517C1.66699 4.36839 1.78366 4.08333 2.01699 3.85C2.25033 3.61667 2.53538 3.5 2.87216 3.5H13.1285C13.4653 3.5 13.7503 3.61667 13.9837 3.85C14.217 4.08333 14.3337 4.36839 14.3337 4.70517V12.2948C14.3337 12.6316 14.217 12.9167 13.9837 13.15C13.7503 13.3833 13.4653 13.5 13.1285 13.5H2.87216ZM8.00033 8.87183L2.66699 5.4615V12.2948C2.66699 12.3547 2.68621 12.4039 2.72466 12.4423C2.7631 12.4808 2.81227 12.5 2.87216 12.5H13.1285C13.1884 12.5 13.2375 12.4808 13.276 12.4423C13.3144 12.4039 13.3337 12.3547 13.3337 12.2948V5.4615L8.00033 8.87183ZM8.00033 7.83333L13.2312 4.5H2.76949L8.00033 7.83333ZM2.66699 5.4615V4.5V12.2948C2.66699 12.3547 2.68621 12.4039 2.72466 12.4423C2.7631 12.4808 2.81227 12.5 2.87216 12.5H2.66699V5.4615Z",
    fill: "#189FAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.9cbcaee59a3dcd8f29b4fb7029b1af7c.svg";
export { ForwardRef as ReactComponent };